import styled from 'styled-components'
import { Image } from './style/components/image'
import { mobile } from './style/media-queries'

export const SectionTitle = styled.h2<{ light?: boolean }>`
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin: 20px;
  color: ${props => (props.light ? '#ffffff' : '#33455b')};

  @media ${mobile} {
    font-size: 28px;
  }
`
export const SectionP2IATitle = styled.h2<{ light?: boolean }>`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin: 20px;
  color: ${props => (props.light ? '#ffffff' : '#33455b')};

  @media ${mobile} {
    font-size: 30px;
  }
`

export const Title3 = styled.h3`
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #33455b;
  margin: 10px 0;
`
export const ContentTitle3 = styled.h3`
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #4a4a4a;
  margin: 10px 0;
`

export const Paragraph = styled.p`
  font-size: 18px;
  line-height: 1.4;
  text-align: center;
  color: #33455b;
  margin: 0 20px;
  white-space: pre-line;
  @media ${mobile} {
    font-size: 16px;
  }
`

export const SmallParagraph = styled(Paragraph)`
  font-size: 18px;
  line-height: 1.56;

  @media ${mobile} {
    font-size: 16px;
  }
`

export const SectionSubTitle = styled.p`
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #a1aab7;
  max-width: 400px;
  margin: 10px 30px;
`

export const ParagraphTitle = styled.h3`
  margin: auto;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
  font-size: 25px;
  color: #33455b;
`

export const ContentParagraph = styled.p`
  color: #6c797f;
  font-size: 16px;
  margin: 10px 20px;
  line-height: 23px;
  text-align: justify;
`

export const ContentParagraph2 = styled.p`
  font-size: 18px;
  line-height: 1.82;
  text-align: left;
  color: #4a4a4a;
`

export const Title4 = styled.h4`
  text-align: left;
  font-size: 18px;
  color: #33455b;
  margin-left: 20px;
  margin-top: 30px;
  margin-bottom: 5px;
`

export const Ul = styled.ul``

export const Li = styled.li`
  margin-left: 20px;
  line-height: 23px;
  color: #6c797f;
`

export const ThinContent = styled.div`
  margin: 0 25% 150px 25%;
  line-height: 1.67;
  width: 50%;
  font-size: 18px;
  color: #33455b;
  @media ${mobile} {
    width: calc(100% - 40px);
    margin: 0 20px 150px 20px;
  }
`

export const ThinContentTitle = styled.h3`
  font-size: 22px;
  color: #33455b;
`

export const ThinContentParagraph = styled.p`
  margin-top: 30px;
  margin-bottom: 5px;
`

export const ThinContentHighlight = styled.span`
  margin-left: -13px;
  font-weight: bold;
`

export const ContentImage = styled(Image)`
  display: block;
  margin: 0 auto;
`

export const SRSpan = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap; /* added line */
  border: 0;
`
